import { Wordmark } from '../components/Wordmark';

export function Loading({ inline = false }: { inline?: boolean }) {
  if (inline) {
    return (
      <div className="center" style={{ minHeight: 160 }} aria-busy="true">
        <div className="spinner" role="status" aria-label="Загрузка" />
      </div>
    );
  }
  return (
    <main className="screen screen--hero">
      <div className="center" style={{ minHeight: 'calc(100 * var(--dvh))' }} aria-busy="true">
        <Wordmark size={30} />
        <div className="spinner" role="status" aria-label="Загрузка" />
      </div>
    </main>
  );
}

export function Message({ title, text, action }: { title: string; text: string; action?: { label: string; onClick: () => void } }) {
  return (
    <main className="screen screen--hero">
      <div className="center" style={{ minHeight: 'calc(100 * var(--dvh))' }}>
        <Wordmark size={30} />
        <h1>{title}</h1>
        <p>{text}</p>
        {action && (
          <button type="button" className="btn-accent" style={{ maxWidth: 280 }} onClick={action.onClick}>
            {action.label}
          </button>
        )}
      </div>
    </main>
  );
}

const SOON: Record<string, { title: string; text: string }> = {
  twin: { title: 'Двойник', text: 'Загрузишь 10 фото один раз — и все тренды будут с твоим лицом. Скоро здесь.' },
  create: { title: 'Создать', text: 'Фото, видео и песни вручную — любые модели. Скоро здесь.' },
  history: { title: 'История', text: 'Здесь будут все твои генерации. Пока пусто.' },
  profile: { title: 'Профиль', text: 'Баланс, партнёрка и настройки появятся совсем скоро.' },
};

export function Soon({ tab }: { tab: string }) {
  const s = SOON[tab] ?? { title: 'Скоро', text: 'Раздел в работе.' };
  return (
    <div className="center">
      <h1>{s.title}</h1>
      <p>{s.text}</p>
    </div>
  );
}
